import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatus = ({ status }) => {
  const getStatusColor = (statusType) => {
    switch (statusType) {
      case 'operational': return 'text-success bg-success/10';
      case 'maintenance': return 'text-warning bg-warning/10';
      case 'degraded': return 'text-error bg-error/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (statusType) => {
    switch (statusType) {
      case 'operational': return 'CheckCircle';
      case 'maintenance': return 'Settings';
      case 'degraded': return 'AlertTriangle';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">System Status</h3>
      <div className="space-y-3">
        {status?.services?.map((service) => (
          <div key={service?.name} className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${getStatusColor(service?.status)}`}>
                <Icon name={getStatusIcon(service?.status)} size={16} />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{service?.name}</p>
                <p className="text-xs text-muted-foreground">{service?.description}</p>
              </div>
            </div>
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(service?.status)}`}>
              {service?.status?.charAt(0)?.toUpperCase() + service?.status?.slice(1)}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Last updated:</span>
          <span className="text-foreground">{new Date(status.lastUpdated)?.toLocaleTimeString()}</span>
        </div>
      </div>
    </div>
  );
};

export default SystemStatus;